/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DepartmentsService {
    /**
     * List all departments
     * Get a paginated list of departments for the authenticated user
     * @returns any List of departments
     * @throws ApiError
     */
    public static e000F92693Bdc7B2C9846C82795(): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/departments',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new department
     * Create a new department
     * @param requestBody
     * @returns any Department created successfully
     * @throws ApiError
     */
    public static d4635Ae7B4C15Efca40765102F9Ff8D6(
        requestBody: {
            department_name: string;
            /**
             * ID of the person who leads this department
             */
            people_id?: number | null;
            email?: string | null;
            mobile?: string | null;
            description?: string | null;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/departments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific department
     * Retrieve details of a specific department
     * @param id Department ID
     * @returns any Department details
     * @throws ApiError
     */
    public static c2D12E14Cd820Aa51B5Ccdc59C29Eb(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/departments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Department not found`,
            },
        });
    }
    /**
     * Update a department
     * Update an existing department
     * @param id Department ID
     * @param requestBody
     * @returns any Department updated successfully
     * @throws ApiError
     */
    public static cbc0A492F9379Edab60B247E7D04A7Ae(
        id: number,
        requestBody: {
            department_name?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/departments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Department not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a department
     * Delete a department
     * @param id Department ID
     * @returns any Department deleted successfully
     * @throws ApiError
     */
    public static f2Ed74585Edcde1C2F968Caa9E9B2(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/departments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Department not found`,
            },
        });
    }
}
